"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCouponType = exports.StripeInvoiceStatus = exports.GetMyStripeSubscriptionEventsQueryEventName = exports.CreateStripeSubscriptionExtendedDTO = exports.parseSubscriptionOptionType = exports.SubscriptionOptionsTypes = exports.SubscriptionMode = exports.SubscriptionProviderTypes = exports.SubscriptionLevels = void 0;
var SubscriptionLevels;
(function (SubscriptionLevels) {
    SubscriptionLevels["BASIC"] = "BASIC";
    SubscriptionLevels["STARTER"] = "STARTER";
    SubscriptionLevels["SCALE_UP"] = "SCALE_UP";
    SubscriptionLevels["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionLevels["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionLevels = exports.SubscriptionLevels || (exports.SubscriptionLevels = {}));
var SubscriptionProviderTypes;
(function (SubscriptionProviderTypes) {
    SubscriptionProviderTypes["STRIPE"] = "STRIPE";
    SubscriptionProviderTypes["PAY_PAL"] = "PAY_PAL";
})(SubscriptionProviderTypes = exports.SubscriptionProviderTypes || (exports.SubscriptionProviderTypes = {}));
var SubscriptionMode;
(function (SubscriptionMode) {
    SubscriptionMode["STRIPE"] = "STRIPE";
    SubscriptionMode["SHOPIFY"] = "SHOPIFY";
})(SubscriptionMode = exports.SubscriptionMode || (exports.SubscriptionMode = {}));
var SubscriptionOptionsTypes;
(function (SubscriptionOptionsTypes) {
    SubscriptionOptionsTypes["TOOLKIT"] = "TOOLKIT";
    SubscriptionOptionsTypes["PAYMENTS_ONLY"] = "PAYMENTS_ONLY";
    SubscriptionOptionsTypes["SHOPIFY_B2B_SUBSCRIPTION"] = "SHOPIFY_B2B_SUBSCRIPTION";
})(SubscriptionOptionsTypes = exports.SubscriptionOptionsTypes || (exports.SubscriptionOptionsTypes = {}));
var parseSubscriptionOptionType;
(function (parseSubscriptionOptionType) {
    parseSubscriptionOptionType["OPTION"] = "OPTION";
    parseSubscriptionOptionType["LEVEL"] = "LEVEL";
})(parseSubscriptionOptionType = exports.parseSubscriptionOptionType || (exports.parseSubscriptionOptionType = {}));
class CreateStripeSubscriptionExtendedDTO {
    constructor(providerResponse, payloadData, companyId, email) {
        this.stripe_price_id = providerResponse.providerPriceId;
        this.trial = providerResponse.onTrial;
        this.stripe_payment_method_id =
            payloadData.stripe_payment_method_id || null;
        this.stripe_customer_id = providerResponse.providerCustomerId;
        this.customer_id = providerResponse.providerCustomerId;
        this.subscription_level = payloadData.subscription_level;
        this.subscription_option = payloadData.subscription_option;
        this.companyId = companyId;
        this.status = providerResponse.status;
        this.email = email;
        this.subscription_id = providerResponse.id;
        this.trialExpiresAt = providerResponse.trialEnds;
        this.providerProductId = providerResponse.providerProductId;
        this.requires3DSecureConfirmation =
            providerResponse.requires3DSecureConfirmation;
        this.currentPeriodStart = providerResponse.startsAt;
        this.currentPeriodEnd = providerResponse.expiresAt;
        this.client_secret = providerResponse.client_secret;
        this.expiresAt = providerResponse.expiresAt;
    }
}
exports.CreateStripeSubscriptionExtendedDTO = CreateStripeSubscriptionExtendedDTO;
var GetMyStripeSubscriptionEventsQueryEventName;
(function (GetMyStripeSubscriptionEventsQueryEventName) {
    GetMyStripeSubscriptionEventsQueryEventName["INVOICE__PAYMENT_ACTION_REQUIRED"] = "invoice.payment_action_required";
    GetMyStripeSubscriptionEventsQueryEventName["INVOICE__PAYMENT_FAILED"] = "invoice.payment_failed";
    GetMyStripeSubscriptionEventsQueryEventName["PAYMENT_INTENT__REQUIRES_ACTION"] = "payment_intent.requires_action";
})(GetMyStripeSubscriptionEventsQueryEventName = exports.GetMyStripeSubscriptionEventsQueryEventName || (exports.GetMyStripeSubscriptionEventsQueryEventName = {}));
var StripeInvoiceStatus;
(function (StripeInvoiceStatus) {
    StripeInvoiceStatus["draft"] = "draft";
    StripeInvoiceStatus["open"] = "open";
    StripeInvoiceStatus["paid"] = "paid";
    StripeInvoiceStatus["uncollectible"] = "uncollectible";
    StripeInvoiceStatus["void"] = "void";
})(StripeInvoiceStatus = exports.StripeInvoiceStatus || (exports.StripeInvoiceStatus = {}));
var StripeCouponType;
(function (StripeCouponType) {
    StripeCouponType["ONCE"] = "once";
    StripeCouponType["REPEATING"] = "repeating";
    StripeCouponType["FOREVER"] = "forever";
})(StripeCouponType = exports.StripeCouponType || (exports.StripeCouponType = {}));
